import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const useStyles = makeStyles({
  searchBox: {
    maxWidth: '100%',
    '& input[type="search"]': {
      paddingLeft: tokens.spacingHorizontalSNudge,
      backgroundImage: 'none',
    },
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: '5px',
  },
  estimatedReach: {
    marginLeft: '10px',
    alignContent: 'center',
  },
  toolTip: {
    maxWidth: '350px',
  },
  toolTipContentWithSpace: {
    marginBottom: tokens.spacingVerticalS,
  },
  toolTipContent: {
    maxHeight: '400px',
    overflowY: 'auto',
    wordWrap: 'break-word',

    '&::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      width: tokens.spacingHorizontalS,
    },
    '&::-webkit-scrollbar-track': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralBackground3,
    },
    '&::-webkit-scrollbar-thumb': {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      backgroundColor: tokens.colorNeutralForeground3,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: tokens.colorNeutralForeground3Hover,
    },
  },
});


const ToolTipContent = ({ i18n, list, styles }) => (
  <div>
    <div className={styles.toolTipContent}><b>{i18n.getString(_TL_('Locations where this audience serves'))}</b></div>
    <div className={styles.toolTipContentWithSpace}>{list.length > 0 ? list.join(', ') : i18n.getString(_TL_('None'))}</div>
    <div className={styles.toolTipContent}><i>{i18n.getString(_TL_('Note: '))}</i>{i18n.getString(_TL_('These locations are based on your campaign settings.'))}</div>
  </div>);

ToolTipContent.propTypes = {
  i18n: PropTypes.shape({ getString: PropTypes.func }).isRequired,
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  styles: PropTypes.shape({
    toolTipContentWithSpace: PropTypes.string,
    toolTipContent: PropTypes.string,
  }).isRequired,
};

export const Estimation = ({
  estimation, localizedMarkets,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();
  const [toolTipVisible, setToolTipVisible] = React.useState(false);

  return (
    <Tooltip
      withArrow
      visible={estimation !== '-' && toolTipVisible}
      onVisibleChange={(_ev, data) => setToolTipVisible(data.visible)}
      content={{ children: <ToolTipContent styles={styles} i18n={i18n} list={localizedMarkets} />, className: styles.toolTip }}
      relationship="description"
    >
      <div className={styles.estimatedReach}>
        {estimation}
      </div>
    </Tooltip>
  );
};

Estimation.propTypes = {
  estimation: PropTypes.string.isRequired,
  localizedMarkets: PropTypes.arrayOf(PropTypes.string).isRequired,
};
